import React, { useState } from 'react';

const VolunteerCredentialModal = ({ open, credentials, onClose }) => {
  const [copied, setCopied] = useState(false);
  if (!open || !credentials) return null;

  const copyToClipboard = () => {
    const text = `Volunteer Email: ${credentials.email}\nPassword: ${credentials.password}`;
    navigator.clipboard.writeText(text)
      .then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      })
      .catch(err => {
        console.error('Failed to copy credentials: ', err);
      });
  };

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <div style={styles.header}>
          <h2 style={styles.title}>Volunteer Account Created</h2>
          <button onClick={onClose} style={styles.closeButtonHeader}>✕</button>
        </div>
        <div style={styles.body}>
          <p style={styles.info}>A volunteer account has been created. Please securely share these credentials. The password will not be shown again.</p>
          <div style={styles.credBox}>
            <div style={styles.credentialItem}>
              <span style={styles.label}>Email:</span>
              <span style={styles.value}>{credentials.email}</span>
            </div>
            <div style={styles.credentialItem}>
              <span style={styles.label}>Password:</span>
              <span style={styles.value}>{credentials.password}</span>
            </div>
          </div>
          <div style={styles.warning}>
            <span style={styles.warningIcon}>⚠️</span>
            <span>These credentials will only be shown once. Please save them securely.</span>
          </div>
        </div>
        <div style={styles.footer}>
          <button
            onClick={copyToClipboard}
            style={copied ? styles.copiedButton : styles.copyButton}
          >
            {copied ? 'Copied!' : 'Copy Credentials'}
          </button>
          <button onClick={onClose} style={styles.closeModalButton}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', background: 'rgba(0,0,0,0.3)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center'
  },
  modal: {
    background: 'white', borderRadius: 8, padding: 0, minWidth: 340, boxShadow: '0 2px 16px rgba(0,0,0,0.2)', textAlign: 'center', width: '90%', maxWidth: 420, overflow: 'hidden', display: 'flex', flexDirection: 'column'
  },
  header: {
    padding: '1.25rem', borderBottom: '1px solid #eee', backgroundColor: 'var(--primary-color)', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'space-between'
  },
  title: { margin: 0, fontSize: '1.4rem', fontWeight: 'bold' },
  closeButtonHeader: { background: 'none', border: 'none', color: 'white', fontSize: '1.5rem', cursor: 'pointer', padding: 0 },
  body: { padding: '1.5rem', background: 'white' },
  info: { color: '#888', marginBottom: '1.5rem', fontSize: '1rem' },
  credBox: { background: '#f8f9fa', border: '1px solid #e9ecef', borderRadius: 6, padding: '1.25rem', marginBottom: '1.5rem' },
  credentialItem: { display: 'flex', marginBottom: '0.75rem', fontSize: '1rem', lineHeight: 1.5 },
  label: { fontWeight: 'bold', minWidth: '100px', color: '#495057' },
  value: { fontFamily: 'monospace', backgroundColor: '#e9ecef', padding: '0.25rem 0.5rem', borderRadius: '4px', flexGrow: 1 },
  warning: { display: 'flex', alignItems: 'center', gap: '0.5rem', backgroundColor: '#fff3cd', color: '#856404', padding: '0.75rem', borderRadius: '6px', fontSize: '0.9rem', marginBottom: '1rem' },
  warningIcon: { fontSize: '1.25rem' },
  footer: { padding: '1rem 1.5rem', borderTop: '1px solid #eee', display: 'flex', justifyContent: 'flex-end', gap: '1rem', background: 'white' },
  copyButton: { padding: '0.75rem 1.25rem', backgroundColor: 'var(--primary-color)', color: 'white', border: 'none', borderRadius: '4px', fontSize: '1rem', cursor: 'pointer', transition: 'background-color 0.3s' },
  copiedButton: { padding: '0.75rem 1.25rem', backgroundColor: 'var(--success-color)', color: 'white', border: 'none', borderRadius: '4px', fontSize: '1rem', cursor: 'pointer', transition: 'background-color 0.3s' },
  closeModalButton: { padding: '0.75rem 1.25rem', backgroundColor: '#6c757d', color: 'white', border: 'none', borderRadius: '4px', fontSize: '1rem', cursor: 'pointer', transition: 'background-color 0.3s' }
};

export default VolunteerCredentialModal;
